module.exports = __webpack_public_path__ + "img/icon-list-white.732a7ef2.svg";